module.exports = __webpack_public_path__ + "static/media/json-file.e1ee4f81.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/json-file.png
// module id = 1876
// module chunks = 0